import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'

import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import SuBankAccountPageUI from './SuBankAccountPageUI.js'

class SuBankAccountPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      // comment it when zybra is down
      bankAccountList: null,
      // bankAccountList: []
      loanBankBalance: null,
      upcomingCollection: null,
      checkedTotal: false,
      checked1: false,
      checked2: false,
      withAccruedAmount: true,
      date: null,
    }
  }

  render() {
    return (
      <SuBankAccountPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        checked1={this.state.checked1}
        checked2={this.state.checked2}
        checkedTotal={this.state.checkedTotal}
        loanBankBalance={this.state.loanBankBalance}
        upcomingCollection={this.state.upcomingCollection}
        upcomingCollectionCurrMonth={this.state.upcomingCollectionCurrMonth}
        onShowDetailsChange1={this.onShowDetailsChange1}
        onShowDetailsChange2={this.onShowDetailsChange2}
        onShowTotalDetailsChange={this.onShowTotalDetailsChange}
        updateAmountClick={this.onUpdateAmountClick}
        onRefreshClick={this.onRefreshClick}
        bankAccountList={this.state.bankAccountList}
        date={this.state.date}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({ errorList: response.errorList, loan: response.loan })
    // comment it when zybra is down
    this.getBankAccount(context, response.loan.accountId)
    this.getLoanBankBalance(context, response.loan.accountId)
    this.getLoanBankBalanceCurrMonth(context, response.loan.accountId)
  }

  getBankAccount(context, accountId) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${accountId}/bankAccounts`,
      cacheKey: CacheKeys.BankAccounts(accountId),
      callback: this.getBankAccountCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getBankAccountCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      bankAccountList: response.bankAccountList,
    })
  }

  getLoanBankBalance(context, accountId) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${accountId}/bankAccounts/loanBankBalance`,
      cacheKey: CacheKeys.LoanBankBalance(accountId),
      callback: this.getLoanBankBalanceCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanBankBalanceCallback = (response) => {
    this.setState({
      date: response.updatedChargesDateF1,
      loanBankBalance: response.loanBankBalance,
      upcomingCollection: response.upcomingCollection,
      errorList: response.errorList
    })
  }

  onUpdateAmountClick = () => {
    RestApiUtils.put(this.props.context, `/api/su/accounts/${this.state.loan.accountId}/repayments/charges`, this.onUpdateAmountCallback)
  }

  onUpdateAmountCallback = (response) => {
    this.setState({
      errorList: response.errorList
    })
  }

  getLoanBankBalanceCurrMonth(context, accountId) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${accountId}/bankAccounts/loanBankBalance?withAccruedAmount=${this.state.withAccruedAmount}`,
      cacheKey: CacheKeys.LoanBankBalanceCurrMonth(accountId),
      callback: this.getLoanBankBalanceCurrMonthCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }
  getLoanBankBalanceCurrMonthCallback = (response) => {
    this.setState({
      upcomingCollectionCurrMonth: response.upcomingCollection,
      errorList: response.errorList
    })
  }

  onShowDetailsChange1 = () => {
    let newChecked1 = !this.state.checked1;
    this.setState({
      checked1: newChecked1
    });
}

  onShowDetailsChange2 = () => {
    let newChecked2 = !this.state.checked2;
    this.setState({
      checked2: newChecked2
    });
  }


  onShowTotalDetailsChange = () => {
    let newChecked = !this.state.checkedTotal
    // CacheManager.setObject(CacheKeys.LendersReport(), { checkedTotal: newChecked })
    this.setState({
      checkedTotal: newChecked
    })
  }

  onRefreshClick = () => {
    let loan = this.state.loan
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(loan.loanId))
    CacheManager.removeObject(CacheKeys.BankAccounts(loan.accountId))
    CacheManager.removeObject(CacheKeys.LoanBankBalance(loan.accountId))
    CacheManager.removeObject(CacheKeys.LoanBankBalanceCurrMonth(loan.accountId))
    this.setState({
      loan: null,
      errorList: null,
      // comment it when zybra is down
      bankAccountList: null,
      loanBankBalance: null,
      loanBankBalanceCurrMonth:null,
    })
    this.getLoan(context)
  }
}

export default withRouter(SuBankAccountPageSF)
